import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './AppRefactored.tsx'
import { CacheService } from './services/cacheService'

// Initialize cache service on app startup
// This handles 7-day auto-clearing of localStorage
CacheService.initialize()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App/>
  </StrictMode>,
)
